import styled from "styled-components";

export const StyledP = styled.p`
  text-align: center;
  margin: 5pt auto;
  margin-top: 15pt;
  color: #777;
`;

export const StyledImg = styled.img<{ width?: string; height?: string }>`
  width: ${(props) => props.width || "390pt"};
  height: ${(props) => props.height || "36pt"};
  max-width: 100%;
  display: block;
  margin: -15px 0px 20px 0px;
`;

const StyledButton = styled.button`
  width: 100px;  // Add this
  text-align: center;
  color: white;
  font-size: 15px;
  padding: 4px;
  border-radius: 3px;
  cursor: pointer;
  box-shadow: 2px 2px #CCC;
  &:hover:enabled {
    opacity: 0.8;
  }
  &:active:enabled {
    opacity: 0.4;
    box-shadow: -2px -2px #CCC;
  }
  &:disabled {
    background-color: #555;
    border: 1px solid #555;
    opacity: 0.5;
    cursor: default;
  }
`

export const StyledBlueButton = styled(StyledButton)`
  background-color: #0054AF;
  border: 1px solid #0054AF;
`

export const StyledGreenButton = styled(StyledButton)`
  background-color: #47B541;
  border: 1px solid #47B541;

`

export const StyledRedButton = styled(StyledButton)`
  background-color: #CA3F43;
  border: 1px solid #CA3F43;

`

export const ButtonGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 15px 25px;
  max-width: 360px; /* 3 buttons * 150px + gaps */
  margin: 0 auto;
`;
